/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-02-19 13:48:32
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-03-04 17:41:17
 * @FilePath: \vue-hepha-order\src\views\product\queryConfig\AvailabilityReportQuery.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const AvailabilityReportQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 4 },
    labelAlign:'right',
    labelColStyle:'150',
    formData:{},
    formField:[
        {
            name:'base.year',
            key:'year',
            type:'select',
            width:'150px',
            placeholder:'base.year',
            options:[
                {
                    label:'2025',
                    value:2025
                },
                {
                    label:'2026',
                    value:2026
                }
            ],
        },
        {
            name:'base.start_week',
            key:'begin_week',
            type:'inputNumber',
            width:'150px',
            min:1,
            max:53,
            show:false,
            placeholder:'base.start_week',
        },
        {
            name:'base.end_week',
            key:'end_week',
            type:'inputNumber',
            width:'150px',
            min:1,
            max:53,
            show:false,
            placeholder:'base.end_week',
        },
        {
            name:'plan.factory',
            key:'factors',
            type:'select',
            width:'450px',
            multiple:true,
            placeholder:'plan.factory',
            options:[
                {
                    label:'ZU',
                    value:'ZU'
                },
                {
                    label:'Maisach',
                    value:'Maisach'
                },
                // {
                //     label:'Cambodia',
                //     value:'Cambodia'
                // },
                {
                    label:'XDS',
                    value:'XDS'
                },
                // {
                //     label:'FSD',
                //     value:'FSD'
                // }
            ],
        },
    ]
}


AvailabilityReportQuery.formField.forEach(item=>{
    AvailabilityReportQuery.formData[item.key] = ''
})


export {
    AvailabilityReportQuery,
}